<template>
  <div>
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-4"></div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold">Benchmark</label>
        </div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold">Weight</label>
        </div>
      </div>
      <div v-for="(field, index) in fields" v-bind:key="index" style="margin-bottom: 10px;">
        <!-- {{field}} -->
        <div v-if="field.reletedField && field.reletedField.length>0">
          <div class="row">
            <div class="col-md-4">
              <!-- <br v-if="field.reletedField.length==0"> -->
              <label :for="field.name" class="form-control-label">{{getLabel(field.label)}}</label>
            </div>
            <div class="col col-md-3" v-if="field.reletedField.length>0">
              <input
                :type="field.type"
                v-model="formData[field.name+'_s']"
                :id="field.name"
                placeholder="Enter S"
                class="form-control"
                v-if="pType=='p1'"
              />
              <input
                :type="field.type"
                v-model="formData[field.name+'_benchmark']"
                :id="field.name"
                placeholder="Enter S"
                class="form-control"
                v-else
              />
              <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
            </div>
            <div class="col col-md-2" v-if="field.reletedField.length>0">
              <input
                :type="field.type"
                v-model="formData[field.name+'_weight']"
                :id="field.name"
                placeholder="Enter Weight"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].Date" class="form-text text-danger">{{errors[field.name].Date}}</small> -->
            </div>
            <div class="col col-md-3" v-if="field.reletedField.length==0">
              <!-- <label class="control-label">Value</label><br/> -->
              <input
                :type="field.type"
                v-model="formData[field.name]"
                :id="field.name"
                placeholder="Enter Weight"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].Date" class="form-text text-danger">{{errors[field.name].Date}}</small> -->
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row" style="margin-bottom: 10px;">
            <!-- {{field}} -->
            <div class="col-md-12">
              <h3>{{getLabel(field.help)}}</h3>
            </div>
          </div>
          <div
            class="row"
            v-for="(fld, ind) in fields[index][field.help]"
            v-bind:key="ind"
            style="margin-bottom: 10px;"
          >
            <div class="col-md-4">
              <!-- <br v-if="field.reletedField.length==0"> -->
              <label :for="fld.name" class="form-control-label">{{getLabel(fld.label)}}</label>
            </div>
            <div class="col col-md-3" v-if="fld.reletedField.length>0">
              <input
                :type="fld.type"
                v-model="formData[fld.name+'_benchmark']"
                :id="fld.name"
                placeholder="Enter Benchmark"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
            </div>
            <div class="col col-md-2" v-if="fld.reletedField.length>0">
              <input
                :type="fld.type"
                v-model="formData[fld.name+'_weight']"
                :id="fld.name"
                placeholder="Enter Weight"
                class="form-control"
              />
              <!-- <small v-if="errors[fld.name].Date" class="form-text text-danger">{{errors[fld.name].Date}}</small> -->
            </div>
            <div class="col col-md-3" v-if="fld.reletedField.length==0">
              <!-- <label class="control-label">Value</label><br/> -->
              <input
                :type="fld.type"
                v-model="formData[fld.name]"
                :id="fld.name"
                placeholder="Enter Weight"
                class="form-control"
              />
              <!-- <small v-if="errors[fld.name].Date" class="form-text text-danger">{{errors[fld.name].Date}}</small> -->
            </div>
          </div>
        </div>
      </div>
      <div class="form-group pull-right">
        <!-- <submitButton @click.prevent="submit" type="submit" class="btn btn-info">Submit</submitButton> -->
        <button @click="save" type="button" class="btn btn-primary">Save</button>
        <button @click="updatedata" type="button" class="btn btn-primary">Save & Update</button>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </form>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { formCommonMixins } from "../../assets/mixins/formcommon.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  mixins: [commonMixins, formCommonMixins],
  props: ["globaldata", "pType"],
  created() {},
  data() {
    return {
      show: false,
      curDate: new Date(),
      fields: [],
      formData: {},
      errors: [],
      defaultSrc: "",
      data: []
    };
  },
  methods: {
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitP11Data();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    save() {
      this.globaldata["update"] = 0;
      this.$refs.smallModal.open();
    },
    updatedata() {
      console.log("UPdate");
      this.globaldata["update"] = 1;
      this.$refs.smallModal.open();
    },
    setP11Data() {
      this.fields = [];
      console.log("Data Set", this.globaldata);
      var frmFields = Object.keys(this.globaldata);
      frmFields.forEach((val, key) => {
        // console.log(val, typeof this.globaldata[val]);
        if (
          val !== "_id" &&
          val !== "type" &&
          val !== "status" &&
          val !== "msg" &&
          val !== "update"
        ) {
          console.log("field", val);
          if (val !== "Banks") {
            var subFields = [];
            var frmSubFields = Object.keys(this.globaldata[val]);
            frmSubFields.forEach((val1, key1) => {
              if (typeof this.globaldata[val][val1] === "object") {
                var f = {
                  label: this.getLabel(val1),
                  name: val + "_" + val1,
                  type: "text",
                  sort_order: key,
                  reletedField: [
                    {
                      label: this.getLabel(val1) + " Benchmark",
                      placeholder: "Enter Benchmark",
                      name: val + "_" + val1 + "_benchmark",
                      type: "text",
                      value: this.globaldata[val][val1]
                        ? this.globaldata[val][val1].benchmark
                        : ""
                    },
                    {
                      label: this.getLabel(val1) + " Weight",
                      placeholder: "Enter Weight",
                      name: val + "_" + val1 + "_weight",
                      type: "text",
                      value: this.globaldata[val][val1]
                        ? this.globaldata[val][val1].weight
                        : ""
                    }
                  ]
                };
              } else {
                var f = {
                  label: this.getLabel(val1),
                  name: val1,
                  type: "text",
                  reletedField: [],
                  value: this.globaldata[val][val1],
                  sort_order: 9999
                };
              }
              subFields.push(f);
            });
            var newData = [];
            newData[val] = subFields;
            this.fields.push(newData);
            // this.fields.push({val: subFields});
          } else {
            console.log("Val", val);
            if (typeof this.globaldata[val] === "object") {
              var f = {
                label: this.getLabel(val),
                name: val,
                type: "text",
                sort_order: key,
                reletedField: [
                  {
                    label: this.getLabel(val) + " Benchmark",
                    placeholder: "Enter Benchmark",
                    name: val + "_benchmark",
                    type: "text",
                    value: this.globaldata[val]
                      ? this.globaldata[val].benchmark
                      : ""
                  },
                  {
                    label: this.getLabel(val) + " Weight",
                    placeholder: "Enter Weight",
                    name: val + "_weight",
                    type: "text",
                    value: this.globaldata[val]
                      ? this.globaldata[val].weight
                      : ""
                  }
                ]
              };
            } else {
              var f = {
                label: this.getLabel(val),
                name: val,
                type: "text",
                reletedField: [],
                value: this.globaldata[val],
                sort_order: 9999
              };
            }
          }
          // if (f) this.fields.push(f);
        }
      });
      console.log(this.fields, this.globaldata);
      // this.setFormData1();
    },
    setP11FormData() {
      console.log("SET Form", this.fields);
      this.formData = {};
      for (var index in this.fields) {
        console.log(index, this.fields[index]);
        let field = this.fields[index];
        if (!field.help)
          field.help =
            Object.keys(this.fields[index]).length > 0
              ? Object.keys(this.fields[index])[0]
              : "";
        if (!field.placeholder) field.placeholder = "";
        if (!field.value) field.value = "";
        // if (!field.help) field.help = "";
        if (field.help === "Banks") {
          this.$set(this.formData, field.name, field.value);
        } else {
          console.log(field, field[field.help]);
          for (var fld in field[field.help]) {
            console.log(fld);
            if (fld !== "help" && fld !== "placeholder" && fld != "value") {
              let bfield = field[field.help][fld];
              console.log(bfield, bfield.name);
              if (!bfield.help) bfield.help = "";
              if (!bfield.placeholder) bfield.placeholder = "";
              if (!bfield.value) bfield.value = "";
              this.$set(this.formData, bfield.name, bfield.value);
              if (bfield.reletedField && bfield.reletedField.length > 0) {
                let relatedData = bfield.reletedField;
                for (var indx in relatedData) {
                  let bfield1 = relatedData[indx];
                  console.log(bfield1);
                  if (!bfield1.placeholder) bfield1.placeholder = "";
                  if (!bfield1.value) bfield1.value = "";
                  if (!bfield1.help) bfield1.help = "";
                  if (!bfield1.type) bfield1.type = "";
                  this.$set(
                    this.formData,
                    bfield1.name,
                    bfield1.value,
                    bfield1.type
                  );
                }
              }
            }
          }
        }
        if (field.reletedField && field.reletedField.length > 0) {
          let relatedData = field.reletedField;
          for (var ind in relatedData) {
            let field1 = relatedData[ind];
            if (!field1.placeholder) field1.placeholder = "";
            if (!field1.value) field1.value = "";
            if (!field1.help) field1.help = "";
            if (!field1.type) field1.type = "";
            this.$set(this.formData, field1.name, field1.value, field1.type);
          }
        }
      }
      console.log("this.formData", this.formData);
      console.log(this.fields, this.globaldata);
    },
    getP11Data() {
      console.log(this.globaldata);
      let data = {};
      // this.globalData = [];
      for (let fd in this.fields) {
        let field = this.fields[fd];
        // console.log("Field", field.name);
        if (field.help && field.help !== "Banks") {
          // this.globaldata[field.help] = [];
          console.log(field[field.help]);
          field[field.help].forEach((fld, k) => {
            console.log(k, fld);
            const fieldName = this.getFieldsName(fld.name, field.help);
            console.log(this.globaldata[field.help], fieldName);
            console.log(
              this.globaldata[field.help][fieldName],
              typeof this.globaldata[field.help][fieldName]
            );
            if (typeof this.globaldata[field.help][fieldName] === "object") {
              this.globaldata[field.help][fieldName] = {
                benchmark: "",
                weight: ""
              };
              this.globaldata[field.help][fieldName].benchmark = this.formData[
                fld.name + "_benchmark"
              ];
              this.globaldata[field.help][fieldName].weight = this.formData[
                fld.name + "_weight"
              ];
            }
          });
        } else {
          if (typeof this.globaldata[field.name] === "object") {
            this.globaldata[field.name] = {
              benchmark: "",
              weight: ""
            };
            this.globaldata[field.name].benchmark = this.formData[
              field.name + "_benchmark"
            ];
            this.globaldata[field.name].weight = this.formData[
              field.name + "_weight"
            ];
          } else {
            console.log(
              "Field",
              field,
              field.name,
              this.globaldata[field.name]
            );
            this.globaldata[field.name] = this.formData[field.name];
          }
        }
      }
      console.log("Global Data" + this.globaldata);
    },
    submitP11Data: function(formData) {
      let myself = this;
      console.log("submit form", this.formData);
      this.getP11Data();
      var data = {};
        data = {
          p11: this.globaldata
        };
      console.log(this.pType, data);
      http.post("updatePFormData", data, (error, response) => {
        console.log("response", response);
        // myself.$router.push({ name: "settings" });
        //TODO:: add company updates into our array in future
        if (response.status === "success") {
          this.$toastr.success("Updated Successfully!", "", {});
        } else {
          this.$toastr.error(response.status, "", {});
        }
      });
    },
    getFieldsName(orgStr, removeStr) {
      return orgStr.replace(removeStr + "_", "");
    }
  },
  watch: {
    globaldata: function(value) {
      console.log("Global data change", value);
      console.log("form type", this.pType);
      this.data = value;
      for (var i in value) {
        this[i] = value[i];
      }
      this.setP11Data();
      this.setP11FormData();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/p11-form.vue